import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Box, Stack, Text } from "@similarweb/ui-components/foundations";

import { ACTIVE_PROVIDERS } from "../../constants/contact-providers";
import type { ContactsWaterfallPageVariant } from "../../types/contacts-waterfall-variant";
import { ProvidersPanel } from "../ProvidersPanel/ProvidersPanel";
import { ComingSoonCard } from "../WaterfallCard/ComingSoonCard";
import { ProviderCard } from "../WaterfallCard/ProviderCard";
import { WaterfallConnector } from "../WaterfallConnector/WaterfallConnector";

const FALLBACK_SLOT_COUNT = 2;

export const WaterfallConfigurationPanel = ({ variant }: { variant: ContactsWaterfallPageVariant }) => {
    const { translate } = useTranslate();
    const startRank = ACTIVE_PROVIDERS.length + 1;

    return (
        <ProvidersPanel
            titleKey={variant === "admin" ? "si.pages.contacts_waterfall.waterfall_configuration.title" : undefined}
            subtitleKey={
                variant === "admin" ? "si.pages.contacts_waterfall.waterfall_configuration.description" : undefined
            }
            flex="1"
            minWidth="0"
            data-automation="contacts-waterfall-configuration"
        >
            <Stack gap="8px">
                {ACTIVE_PROVIDERS.map((provider, index) => (
                    <Box key={provider.domain}>
                        <ProviderCard
                            provider={provider}
                            rank={index + 1}
                        />
                    </Box>
                ))}
                {Array.from({ length: FALLBACK_SLOT_COUNT }, (_, index) => (
                    <Box key={`slot-${startRank + index}`}>
                        <WaterfallConnector />
                        <ComingSoonCard rank={startRank + index} />
                    </Box>
                ))}
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon[200]}
                    textAlign="center"
                >
                    {translate("si.pages.contacts_waterfall.slot.description")}
                </Text>
            </Stack>
        </ProvidersPanel>
    );
};
